import type { EntityOption } from '@/components/EntitySelect';
import { getDeal, listDeals } from './api';

/** Server search for the deal picker (EntitySelect). */
export async function searchDeals(query: string): Promise<EntityOption[]> {
  const page = await listDeals({ search: query || undefined });
  return page.results.map((d) => ({ value: String(d.id), label: d.name }));
}

/** Resolve a deal's name for a preselected id (edit mode). */
export async function resolveDealLabel(value: string): Promise<string | null> {
  if (!value) return null;
  const deal = await getDeal(Number(value));
  return deal.name;
}
